import { useEffect, useState } from "react";
import "./style.scss"
import { goWhatsApp } from "../../../utils/data/index";
import IntermediatePage from "../../../components/IntermediatePage/index";
const Singapore = () => {
    useEffect(() => {
        document.title = 'Online Chinese Tutoring Courses for Singapore - Sinobus';
    }, [])
    const [isShow, setIsShow] = useState(false);
    const goUrl = () => {
        // goWhatsApp();
        setIsShow(true)
    }
    const handleClose = () => {
        setIsShow(false);
    }
    return <div className="singapore">
        <a className="chatSg">
            <div className="chatSgTxt">限时抢免费试听</div>
            <img onClick={() => { goUrl() }} src="../assets/whatsapp.png" alt="" />
        </a>
        <img className="imgDf" src="../assets/sg-page-m2.png" alt="" onClick={() => { goUrl() }} />
        <img className="imgPc" src="../assets/sg-page-pc2.png" alt="" onClick={() => { goUrl() }} />
        <IntermediatePage isShow={isShow} onClose={handleClose} />

    </div>
}
export default Singapore;